/**
 * Whether the application's realtime socket is currently up (mapd-issues#664).
 *
 * The socket itself lives in `WebSocket.js`, which announces `connect` and
 * `disconnect` as window events. Anything listening from the start hears them;
 * anything that attaches later — Gala Seating's Seat Assignment session is
 * created when the admin opens a Design, long after the socket was opened —
 * missed them and has no way to ask.
 *
 * This is that way to ask. It is a one-shot seed for a listener attaching late,
 * not a second source of truth: once attached, the Seat Assignment module's
 * `connectionState` is what the UI reads.
 *
 * It is kept apart from `WebSocket.js` on purpose, so that asking the question
 * does not drag the socket and `@eventdex/core` into modules that only need the
 * answer.
 */

let connected = false;

/** Called by the socket's own connect/disconnect handlers. */
export function setRealtimeConnected(value: boolean): void {
  connected = value;
}

/** Whether the socket was up the last time it said anything. */
export function isRealtimeConnected(): boolean {
  return connected;
}
